import React, { createContext, useContext } from 'react';

export const CometDContext = createContext({});

export const CometDProvider = ({ cometdInstance, children }) => {
  return (
    <CometDContext.Provider value={cometdInstance}>
      {children}
    </CometDContext.Provider>
  );
};

export const useCometdContext = () => useContext(CometDContext);
